export default "__VITE_PUBLIC_ASSET__01b7804a__"